import { RomaniaMaxPriceGroupItemStatusSerializable } from 'com.cogvio.pricemonitor.api';
import { Product } from '~/Api/Product';
import { ProductItemStatus } from '~/libs/ui/atoms/ProductStatusIcon';

interface ModuleProduct {
	readonly product: Product;
	readonly datasource: {
		readonly suklReference: boolean;
	};
	readonly selected: boolean;
}

interface ModuleProductDataSource {
	readonly product: Product;
	readonly referenceDataSource: boolean;
	readonly selected: boolean;
}
interface ModuleProductWithGroupItemStatus extends ModuleProductDataSource {
	readonly groupItemStatus: RomaniaMaxPriceGroupItemStatusSerializable;
}

export const isSuklReferenceProduct = (product: ModuleProduct) =>
	(!product.datasource.suklReference && !product.selected) ||
	product.product.status.isRemoved() ||
	product.product.status.isBeforeIntroduction();

export const isReferenceDataSource = (product: ModuleProductDataSource) =>
	(!product.referenceDataSource && !product.selected) ||
	product.product.status.isRemoved() ||
	product.product.status.isBeforeIntroduction();

export const isInvalidProduct = (product: ModuleProductWithGroupItemStatus) =>
	product.groupItemStatus === ProductItemStatus.ALTERNATIVE_DATASOURCE ||
	product.groupItemStatus === ProductItemStatus.MISSING_IN_DATASET ||
	product.groupItemStatus === ProductItemStatus.MISSING_PRICES ||
	product.groupItemStatus === ProductItemStatus.AFTER_VALIDITY;

export const shouldBeDisplayedAsAlternativeProduct = (product: ModuleProductWithGroupItemStatus) =>
	!product.selected || (isInvalidProduct(product) && !product.selected);
